import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import MetadataApliableFilterCard from '../../ui-parts/MetadataApliableFilterCard';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import SearchResultThumbnailViewSearchResultCard from './SearchResultThumbnailViewSearchResultCard';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

// 2024.5.8 MyMine Version1.5対応 Add Start
/**
 * Search Result(Thumbnail view) Page Component
 */
const SearchResultThumbnailView = (props) => {
  const location = useLocation();
  let {
    searchValue,
    filterList,
    selectedId,
    // 2024.9.16 MyMine Version2.0対応 Add Start
    isLoadSearchKeyword,
    // 2024.9.16 MyMine Version2.0対応 Add End

  } = location.state;
  const screenId = 'MyM402';
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [filterResult, setFilterList] = useState(null);
  const [selectedSortBy, setSelectedSortBy] = useState(selectedId ?? 0);
  const [apliableFilterList, setApliableFilterList] = useState(filterList ?? []);
  const [isInitLoaded, setIsInitLoaded] = useState(false);
  const [checkedList, setCheckedList] = useState(filterList ?? []);
  // 2024.9.16 MyMine Version2.0対応 Add Start
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2024.9.16 MyMine Version2.0対応 Add End

  // ソート順のDropDownList用変数
  const sortByDDL = [
    { value: 0, text: controlSettings.LabelList.ddlSortBy1, sortItem: 'UPLOAD_DATE DESC' },
    { value: 1, text: controlSettings.LabelList.ddlSortBy2, sortItem: 'UPLOAD_DATE ASC' },
    { value: 2, text: controlSettings.LabelList.ddlSortBy3, sortItem: 'EXTENSION ASC' },
    { value: 3, text: controlSettings.LabelList.ddlSortBy4, sortItem: 'NAME_DISP ASC' },
  ];

  /**
   * プレビュー処理
   * @param {Event} e イベント引数
   * @param {string} fileId ファイルID
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  /**
   * SortByドロップダウンリスト変更時処理
   * @param {any} e イベント引数
   */
  const handleSortByChange = (e) => {
    setSelectedSortBy(e.target.value);
  }

  /** 初期表示時 */
  useEffect(() => {

    /**
     * 初期情報取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSearchResultLoadSuccess = (result) => {
      setSearchResult(result.Result);
      setFilterList(result.FilterList);
      setIsLoading(false);
    }

    /**
     * 初期情報取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackSearchResultLoadFaild = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    const paramObj = {
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      LimitMaxRowCount: screenSettings.MaxRowCount,
      // 2024.9.16 MyMine Version2.0対応 Add Start
      IsEventSenderSearchKeyword: isLoadSearchKeyword === true,
      // 2024.9.16 MyMine Version2.0対応 Add End
      SearchWord: utility.sanitize(searchValue) ?? '',
      ...(apliableFilterList.length > 0 ? {
        FilterMetadataIds: apliableFilterList.join(',')
      } : {}),
      IsRequestThumbnail: true,
    };

    apiRequest.requestJson(`api/box-file/search-result-load?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSearchResultLoadSuccess, callbackSearchResultLoadFaild);
    setIsInitLoaded(true);
  }, []);

  /** フィルタ適用時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    if (pageNumber === 1) {
      requestSearch();
    } else {
      setPageNumber(1);
    }
  }, [apliableFilterList]);

  /** ソート/ページング切り替え時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    requestSearch();
  }, [pageNumber, selectedSortBy]);

  /** リクエスト処理  */
  const requestSearch = () => {

    /**
     * 一覧ページ取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSuccessSearchResultPage = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (pageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(pageNumber - 1);
        return;
      }

      setSearchResult(Object.assign(searchResult, result));
      setIsLoading(false);
    }

    /**
     * 一覧ページ取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackFaildSearchResultPage = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    setIsLoading(true);

    const paramObj = {
      PageNumber: pageNumber,
      LimitMaxRowCount: screenSettings.MaxRowCount,
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      SearchWord: utility.sanitize(searchValue) ?? '',
      FilterMetadataIds: apliableFilterList.join(','),
      IsRequestThumbnail: true,
    };

    apiRequest.requestJson(`api/box-file/search-result-list-page?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSuccessSearchResultPage, callbackFaildSearchResultPage);
  }

  if (searchResult === null)
    return <MyMProgress />

  return (
    <Box className='pb-3'>
      <Grid container>
        <Grid item xs={12} lg={9.3}>
          <SearchResultThumbnailViewSearchResultCard
            screenId={screenId}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            searchResult={searchResult}
            onSortByChange={handleSortByChange}
            onClickPreview={onClickPreview}
            controlSettings={controlSettings}
            messageList={messageList}
            sortByDDL={sortByDDL}
            keyword={searchValue}
            selectedSortBy={selectedSortBy}
            setIsLoading={setIsLoading}
            searchValue={utility.sanitize(searchValue) ?? ''}
            screenSettings={screenSettings}
            apliableFilterList={apliableFilterList}
            isLoading={isLoading}
            metadataList={filterResult}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
            setApliableFilterList={setApliableFilterList}
          />
        </Grid>
        {isPc &&
          <Grid item xs={12} lg={2.7}>
            <MetadataApliableFilterCard
              cardTitle={controlSettings.LabelList.lblFilterResultsByTitle}
              metadataList={filterResult}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </Grid>
        }
      </Grid>
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </Box>
  );
}
export default SearchResultThumbnailView;
// 2024.5.8 MyMine Version1.5対応 Add End